<svelte:options tag="pzemng-offer-not-possible" immutable={true}/>
<script>
    import { createEventDispatcher } from 'svelte';

    export let zipcode = '';
    export let housenumber = '';
    export let housenumberaddition = '';

    const dispatch = createEventDispatcher();

    function closeModal() {
        dispatch('close');
    }

</script>

<div class="backdrop">
    <div class="layout-container">
        <article class="s-modal">
            <button class="s-modal__close" aria-label="Sluiten" on:click={closeModal}>
                <span class="icon icon-close"></span>
            </button>
            <header class="s-modal__header">
                <div class="address">
                    <span class="address__box">{zipcode.substring(0, 4)}</span>
                    <span class="address__box">{zipcode.substring(4)}</span>
                    <span class="address__box address__box--number">{housenumber + housenumberaddition}</span>
                </div>
                <h2 class="s-modal__title">Op dit adres mogen we helaas niet leveren</h2>
            </header>
            <p class="s-modal__text">
                U heeft een kleinverbruiksaansluiting. PZEM mag alleen leveren aan kleinverbruiksaansluitingen indien er van dezelfde productsoort (elektriciteit of gas) ook een grootverbruiksaansluiting aanwezig is. Dit is wettelijk bepaald. Een elektriciteitsaansluiting met een totale maximale capaciteit van niet meer dan 3 x 80 Ampère of een gasaansluiting met een totale maximale capaciteit van niet meer dan 40 ㎥ per uur zijn kleinverbruiksaansluitingen.
            </p>
            <footer class="s-modal__footer">
                <a class="button button--tertiary"
                   href="https://www.pzem.nl/uitleg-kleinverbruikersaansluitingen"
                   aria-label="Meer informatie"
                >
                    Meer informatie
                </a>
                <button class="button"
                        aria-label="Sluiten"
                        on:click={closeModal}
                >
                    Sluiten
                </button>
            </footer>
        </article>
    </div>
</div>

<style>
    @import "@nedbase/pzem-ui/style";

    .backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        background-color: rgba(var(--color-black-rgb), .2);
        overflow: auto;
        z-index: 1000000;
    }

    .layout-container {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .address {
        display: flex;
        flex-flow: row nowrap;
        margin-bottom: var(--spacing--200);
    }

    .address__box {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: var(--spacing--50) var(--spacing--75);
        border: 1px solid var(--color-error);
        border-radius: 6px;
        font-weight: var(--font-weight--bold);
        font-size: 24px;
        text-transform: uppercase;
    }

    .address__box:first-of-type::after {
        content: '';
        position: absolute;
        top: 6px;
        bottom: 6px;
        right: -4px;
        width: 6px;
        background-color: var(--color-background--light);
        z-index: 2;
    }

    .address__box--number {
        margin-left: var(--spacing--75);
        text-transform: none;
    }

    .button {
        display: flex;
        align-items: center;
        padding: var(--spacing) var(--spacing--275);
        margin-left: var(--spacing);
        white-space: nowrap;
        text-decoration: none;
        font-weight: var(--font-weight--semi-bold);
        color: var(--color-secondary--contrast);
        background: var(--color-secondary);
        border: 1px solid var(--color-secondary);
        border-radius: var(--border-radius--large);
        transition: all .2s ease;
        outline: none;
        cursor: pointer;
    }

    .button:focus {
        border-color: var(--color-link--focus);
    }

    .button:hover {
        color: var(--color-primary--contrast);
        background: var(--color-primary);
        border-color: var(--color-primary);
    }

    .button--tertiary {
        margin-left: 0;
        padding: var(--spacing) var(--spacing--175);
        font-weight: var(--font-weight--medium);
        color: var(--color-gray--75);
        background: var(--color-white);
        border-color: var(--color-white);
    }

    .button--tertiary:focus {
        color: var(--color-link--focus);
    }

    .button--tertiary:hover {
        color: var(--color-primary);
        background: var(--color-white);
        border-color: var(--color-primary);
    }

    .s-modal {
        position: relative;
        width: 50%;
        height: auto;
        min-width: 600px;
        max-height: 90%;
        margin: var(--spacing--50) 0;
        padding: var(--spacing--450) 5%;
        background: var(--color-background--light);
        border-radius: 7px;
        overflow: auto;
    }

    .s-modal__close {
        position: absolute;
        top: var(--spacing--150);
        right: var(--spacing--100);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: var(--spacing--75);
        background: none;
        border: 1px solid transparent;
        outline: 0;
        border-radius: 50%;
        font-size: 26px;
        cursor: pointer;
        transition: all .2s ease;
    }

    .s-modal__close:focus {
        border-color: var(--color-link--focus);
    }

    .s-modal__close:hover {
        background: var(--color-background--blue);
    }

    .s-modal__footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-top: var(--spacing--350);
    }

    @media (max-width: 812px) {
        .s-modal {
            width: 100%;
            min-width: 0;
            padding: var(--spacing--450) var(--spacing) var(--spacing--75);
        }

        .s-modal__close {
            top: var(--spacing--25);
            right: var(--spacing--25);
        }

        .s-modal__title {
            font-size: 24px;
        }

        .s-modal__text {
            line-height: 1.8;
        }

        .s-modal__footer {
            flex-flow: row wrap-reverse;
            justify-content: stretch;
            padding-top: var(--spacing--250);
        }

        .address {
            margin-bottom: var(--spacing--150);
        }

        .button {
            display: block;
            width: 100%;
            margin: 0 0 var(--spacing--25);
            text-align: center;
        }

        .button--tertiary {
            margin: 0;
        }
    }
</style>
